// src/App.js
import './App.css';
import styled from 'styled-components';
import { colors, radii, space } from './styles/tokens';
import { Nav } from './components/Nav';
import Hero from './sections/Hero';
import About from './sections/About';
import Projects from './sections/Projects';
import Skills from './sections/Skills';
import Contact from './sections/Contact';
import Footer from './sections/Footer';

const SkipLink = styled.a`
  position: absolute;
  top: ${space[2]};
  left: ${space[2]};
  padding: ${space[1]} ${space[2]};
  background: ${colors.accent};
  color: ${colors.bg};
  font-weight: 600;
  border-radius: ${radii.sm};
  z-index: 1000;
  transform: translateY(-150%);
  transition: transform 150ms ease;
  &:focus { transform: translateY(0); }
`;

function App() {
  return (
    <div className="App">
      <SkipLink href="#main">Skip to content</SkipLink>
      <Nav />
      <main id="main">
        <Hero />
        <About />
        <Projects />
        <Skills />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
